import * as locales from "../../../date-fns/locale.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ...locales
  }
};